"use client";

import { useState } from "react";
import { DemoRamsGenerator } from "./demo-generator";
import { PhotoRamsUploader } from "@/components/demo/photo-rams-uploader";

const TABS = [
  { id: "describe", label: "Describe your job" },
  { id: "photo", label: "Upload a site photo" },
] as const;

type TabId = (typeof TABS)[number]["id"];

export function DemoTabs() {
  const [activeTab, setActiveTab] = useState<TabId>("describe");
  const [photoDescription, setPhotoDescription] = useState<string | null>(null);

  const handlePhotoGenerate = (description: string) => {
    setPhotoDescription(description);
    setActiveTab("describe");
  };

  return (
    <div className="mt-10">
      {/* Tab toggle */}
      <div className="mb-4 flex rounded-lg border border-gray-200 bg-gray-50 p-1">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => {
              setActiveTab(tab.id);
              if (tab.id === "describe") setPhotoDescription(null);
            }}
            className={`flex-1 rounded-md px-4 py-2 text-sm font-semibold transition-colors ${
              activeTab === tab.id
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab content — min height prevents layout jump when switching tabs */}
      <div className="min-h-[420px]">
        {activeTab === "describe" ? (
          <DemoRamsGenerator initialDescription={photoDescription ?? undefined} />
        ) : (
          <PhotoRamsUploader onGenerate={handlePhotoGenerate} />
        )}
      </div>
    </div>
  );
}
